import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=bd4c8d5a&scoped=true&"
import script from "./Software.vue?vue&type=script&lang=js&"
export * from "./Software.vue?vue&type=script&lang=js&"
import style0 from "./Software.vue?vue&type=style&index=0&id=bd4c8d5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4c8d5a",
  null
  
)

export default component.exports